import React from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import StepsAddCampaigns from "../../StepsAddCampaigns";
import TitleBar from "../../../../partials/content/TitleBar";

function AllTypesBannerCampaigns() {
  const params = useParams();
  const userID = params.id;
  let items = [
    {
      title: "نوع کمپین",
      status: true,
      link: "/campaigns/coworker/all-type/" + userID,
    },
    {
      title: "نوع کمپین بنری",
      status: true,
      link: "/campaigns/coworker/all-type-banner/" + userID,
    },
    {
      title: "تنظیمات کمپین",
      status: false,
      link: "/campaigns/banner/add-simple",
    },
  ];

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="نوع کمپین بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <StepsAddCampaigns items={items} />

              <div className="container-fluid" id="type-all-campaigns">
                <div className="row">
                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-2 pb-lg-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between ">
                      <div>
                        <div className="item-img text-center py-3">
                          <img
                            className="w-50"
                            src="/assets/img/campaign-banner.svg"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>بنری موضوعی</b>
                        </div>
                        <div className="item-line">
                          <hr className="border border-top-1" />
                        </div>
                        <div className="item-list-data">
                          <p className="text-justify p-4 m-0">
                            تبلیغات بنری شما با توجه به موضوع کسب و کار شما و
                            موضوع سایت های نمایش دهنده به کاربران مرتبط با کسب و
                            کار شما نمایش داده می شود و باعث معرفی کسب و کار و
                            افزایش فروش می گردد.
                          </p>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center pt-3   ">
                          <Link
                            to={`/campaigns/coworker/banner/simple/add-group-site-publisher/${userID}`}
                            className="btn btn-success"
                          >
                            انتخاب
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-2 pb-lg-0  campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between ">
                      <div>
                        <div className="item-img text-center py-3">
                          <img
                            className="w-50"
                            src="/assets/img/campaign-banner-contextual.svg"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>بنری ریتارگتینگ</b>
                        </div>
                        <div className="item-line">
                          <hr className="border border-top-1" />
                        </div>
                        <div className="item-list-data">
                          <p className="text-justify p-4 m-0">
                            در این حالت تبلیغات شما به کاربرانی که حداقل یک بار
                            به سایت شما مراجعه کردن نمایش داده می شود و با نمایش
                            چند باره تبلیغات به مخاطب کسب و کار شما در ذهن مخاطب
                            نقش می بندد و در زمان مناسب به شما رجوع می کند.
                          </p>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center  pt-3   ">
                          <span className="btn btn-secondary">به زودی</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-4 pb-4 pb-sm-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 rounded h-100 d-flex flex-column justify-content-between">
                      <div>
                        <div className="item-img text-center py-3">
                          <img
                            className="w-50"
                            src="/assets/img/campaign-banner-contextual.svg"
                          />
                        </div>
                        <div className="item-name text-center">
                          <b>بنری هدفمند (موضوعی + کلیدواژه‌ای)</b>
                        </div>
                        <div className="item-line">
                          <hr className="border border-top-1" />
                        </div>
                        <div className="item-list-data">
                          <p className="text-justify p-4 m-0">
                            در این نوع از تبلیغات شما می توانید در صفحات بر اساس
                            موضوع و کلید واژه های مرتبط و کاربران براساس جنسیت و
                            رفتار آنها تبلیغات خود را نمایش داده و با توجه به
                            هدفمندی تعریف شده به کاربران هدف معرفی شوید.
                          </p>
                        </div>
                      </div>
                      <div className="pb-3">
                        <div className="item-more-btn text-center  pt-3  ">
                          <span className="btn btn-secondary">به زودی</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllTypesBannerCampaigns;
